import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import L from "leaflet";

// Fix default marker icons (webpack bundling issue)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const accentIcon = L.divIcon({
  className: "",
  html: `<div style="background:#DC2626;width:24px;height:24px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:3px solid white;box-shadow:0 4px 8px rgba(0,0,0,0.2);"><div style="background:white;width:8px;height:8px;border-radius:50%;position:absolute;top:5px;left:5px;"></div></div>`,
  iconSize: [24, 24],
  iconAnchor: [12, 24],
});

function ClickHandler({ onClick }) {
  useMapEvents({
    click(e) {
      onClick?.({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

export function TownMap({
  reports = [],
  center = [40.7128, -74.006],
  zoom = 12,
  height = 480,
  onClick,
  selected,
  fillHeight = false,
}) {
  const containerStyle = fillHeight ? { height: "100%" } : { height };
  return (
    <div
      className="rounded-2xl overflow-hidden border border-[var(--te-divider)] shadow-sm h-full"
      style={containerStyle}
      data-testid="town-map"
    >
      <MapContainer center={center} zoom={zoom} scrollWheelZoom style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {onClick && <ClickHandler onClick={onClick} />}
        {selected && (
          <Marker position={[selected.lat, selected.lng]} icon={accentIcon}>
            <Popup>Selected location</Popup>
          </Marker>
        )}
        {reports.filter((r) => r.lat && r.lng).map((r) => (
          <Marker key={r.id} position={[r.lat, r.lng]} icon={accentIcon}>
            <Popup>
              <div style={{ minWidth: 180 }}>
                <div className="font-semibold mb-1" style={{ color: "var(--te-text)" }}>{r.title}</div>
                <div className="text-xs" style={{ color: "var(--te-text-secondary)" }}>
                  {r.address || `${r.lat.toFixed(4)}, ${r.lng.toFixed(4)}`}
                </div>
                <a href={`/reports/${r.id}`} className="text-xs font-medium mt-2 inline-block" style={{ color: "var(--te-primary)" }}>
                  View report →
                </a>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
